module.exports = __webpack_public_path__ + "img/img3.5c4c0135.jpg";